import { userStorage } from 'helpers/user-storage';
import { permissionConstants } from '../constants';


let loggedPermissions = userStorage.getPermissions();
console.log(userStorage);

const defaultState = loggedPermissions ? { loggedPermissions } : {};

export function loggedpermissions(state = defaultState, action) {
  switch (action.type) {
    case permissionConstants.GET_LOGGED_REQUEST:
      return { loggedPermissions: action.data };
    case permissionConstants.GET_LOGGED_SUCCESS:
      return {
        loggedPermissions: action.data.rows
      };
    case permissionConstants.GET_LOGGED_FAILURE:
      return {};
    default:
      return state
  }
}
